const PRICE_GROUPING_SPACES = /[\s\u00a0\u202f]/g;
const PRICE_GROUPING_SPACE = /[\s\u00a0\u202f]/;

export const normalizePriceInput = (value: unknown): string => {
  const compactValue = String(value ?? "").replace(PRICE_GROUPING_SPACES, "").replace(",", ".");
  const [integerPart = "", ...fractionParts] = compactValue.replace(/[^\d.]/g, "").split(".");

  if (!fractionParts.length) return integerPart;

  return `${integerPart}.${fractionParts.join("")}`;
};

export const formatPriceInput = (value: unknown): string => {
  const normalizedValue = normalizePriceInput(value);
  const [integerPart = "", fractionPart] = normalizedValue.split(".");
  const groupedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  return fractionPart === undefined ? groupedIntegerPart : `${groupedIntegerPart},${fractionPart}`;
};

export const getPriceInputCaretPosition = (
  rawValue: string,
  rawCaretPosition: number,
  formattedValue = formatPriceInput(rawValue),
): number => {
  const safeCaretPosition = Math.max(0, Math.min(rawCaretPosition, rawValue.length));
  const meaningfulCharactersBeforeCaret = normalizePriceInput(
    rawValue.slice(0, safeCaretPosition),
  ).length;

  if (meaningfulCharactersBeforeCaret === 0) return 0;

  let meaningfulCharactersCount = 0;

  for (let index = 0; index < formattedValue.length; index += 1) {
    if (!PRICE_GROUPING_SPACE.test(formattedValue[index])) {
      meaningfulCharactersCount += 1;
    }

    if (meaningfulCharactersCount >= meaningfulCharactersBeforeCaret) {
      return index + 1;
    }
  }

  return formattedValue.length;
};
